export function LearnMoreLink({ link }: { link: string }) {
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="text-brand-primary underline hover:text-brand-tertiary"
    >
      Learn more
    </a>
  );
}
